import PropTypes from "prop-types";
import classNames from "classnames";
import {
  accToggleCard,
  accSectionStyle,
  accSectionLabel,
  accHeader,
} from "./accordian.module.scss";
import Image from "next/image";
import { IMAGE_BASE_PATH } from "@/config/config";

const AccordianSection = ({ isOpen, isDisplay, label, onClick, children }) => {
  return (
    <>
      <article
        className={classNames(
          `d-${isDisplay ? "block" : "none"} mb-3`,
          isOpen ? accToggleCard : "",
          isOpen ? "px-4 pb-2 pb-md-0" : ""
        )}
      >
        <header
          aria-hidden="true"
          onClick={onClick}
          // style={{ cursor: "pointer", borderRadius: "33px" }}
          className={classNames(
            "d-flex align-items-center justify-content-between py-2 pt-md-2 pb-md-0",
            !isOpen ? "px-4" : "",
            !isOpen ? accToggleCard : "",
            accHeader
          )}
        >
          <span className={classNames(accSectionLabel)}>{label}</span>
          <span>
            {!isOpen ? (
              <Image
                src={`${IMAGE_BASE_PATH}/images/angle-down.svg`}
                alt="angle down"
                width={25}
                height={25}
              />
            ) : (
              <Image
                src={`${IMAGE_BASE_PATH}/images/angle-top.svg`}
                alt="angle top"
                width={25}
                height={25}
              />
            )}
          </span>
        </header>

        <aside
          className={classNames(
            `d-${isOpen ? "block" : "none"}`,
            accSectionStyle
          )}
        >
          {children}
        </aside>
      </article>
      <div
        className="d-none d-md-block"
        style={{ border: "1px dashed #bcbcbc" }}
      />
    </>
  );
};

AccordianSection.defaultProps = {
  isDisplay: true,
};

AccordianSection.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
  isDisplay: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AccordianSection;
